import { render } from "./first_question.vue?vue&type=template&id=2c42f8fe&scoped=true"
import script from "./first_question.vue?vue&type=script&lang=js"
export * from "./first_question.vue?vue&type=script&lang=js"

import "./first_question.vue?vue&type=style&index=0&id=2c42f8fe&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c42f8fe"]])

export default __exports__